import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "../styles/ReturningUserPage.css";
import { setIdentifier } from "../utils/auth";
import { useAuth } from "../auth/useAuth";

const ReturningUserPage = () => {
  const [emailOrUsername, setEmailOrUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false); // ✅ NEW
  const [rememberMe, setRememberMe] = useState(true);

  const [emailOrUsernameErr, setEmailOrUsernameErr] = useState("");
  const [passwordErr, setPasswordErr] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.state?.postLoginRedirect;

  const { refresh } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loading) return;

    setErrorMessage("");
    setSuccessMessage("");
    setEmailOrUsernameErr("");
    setPasswordErr("");

    const id = emailOrUsername.trim();
    const pwd = password;

    let hasError = false;
    if (!id)  { setEmailOrUsernameErr("please enter your email or username."); hasError = true; }
    if (!pwd) { setPasswordErr("please enter your password."); hasError = true; }
    if (hasError) return;

    setLoading(true);
    try {
      const isEmail = id.includes("@");

      const response = await fetch("https://squid-app-6s2hc.ondigitalocean.app/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          email: isEmail ? id : undefined,
          username: !isEmail ? id : undefined,
          password: pwd,
          rememberMe
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok && data?.success) {
        const identifier = data.email || (isEmail ? id : null);
        if (identifier) {
  setIdentifier(identifier, {
    remember: rememberMe
  });
}

        setSuccessMessage("login successful!");
        setPassword("");

        await refresh();

if (redirect?.path) {
  navigate(redirect.path, {
    state: redirect.state,
    replace: true
  });
} else {
  navigate("/home-page", {
    replace: true
  });
}
      } else {
        setErrorMessage(data?.message || "invalid email/username or password.");
      }
    } catch {
      setErrorMessage("an error occurred. please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="returning-user-page">
      <div className="returning-wrap">
        <form onSubmit={handleLogin} className="login-form" noValidate>
          <div className="input-group">
            <label htmlFor="emailOrUsername" className="sr-only">Email or Username</label>
            <input
              id="emailOrUsername"
              type="text"
              value={emailOrUsername}
              onChange={(e) => {
                setEmailOrUsername(e.target.value);
                setEmailOrUsernameErr("");
                setErrorMessage("");
              }}
              placeholder="enter your email or username"
              className={emailOrUsernameErr ? "has-error" : ""}
              aria-invalid={!!emailOrUsernameErr}
              autoComplete="username email"
              spellCheck="false"
              inputMode="email"
            />
          </div>

          {/* ✅ Password row wrapper so the icon can sit inside */}
          <div className="input-group password-row">
            <label htmlFor="password" className="sr-only">Password</label>

            <input
              id="password"
              type={showPw ? "text" : "password"}   // ✅ NEW
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordErr("");
                setErrorMessage("");
              }}
              placeholder="enter your password"
              className={passwordErr ? "has-error" : ""}
              aria-invalid={!!passwordErr}
              autoComplete="current-password"
            />

            <button
              type="button"
              className="pw-toggle"
              onClick={() => setShowPw((v) => !v)}
              aria-label={showPw ? "hide password" : "show password"}
              aria-pressed={showPw}
              title={showPw ? "hide password" : "show password"}
            >
              {showPw ? "hide" : "show"} 
            </button>
          </div>


          {(emailOrUsernameErr || passwordErr || errorMessage || successMessage) && (
            <p
              className={`status-message ${
                (emailOrUsernameErr || passwordErr || errorMessage) ? "is-error" : "is-success"
              }`}
              role="status"
              aria-live="polite"
            >
              {emailOrUsernameErr || passwordErr || errorMessage || successMessage}
            </p>
          )}

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? "logging in…" : "login"}
          </button>
          <label className="remember-row">
  <input
    type="checkbox"
    checked={rememberMe}
    onChange={(e) => setRememberMe(e.target.checked)}
  />

  <span className="remember-label">
    stay signed in
  </span>
</label>
        </form>

        <div className="forgot-password-link">
          <p>
            forgot your password? <Link to="/forgot-password">reset it</Link>.
          </p>
        </div>
      </div>
    </main>
  );
};

export default ReturningUserPage;
